// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0359a946","977":"fd74c01a"}[chunkId] + ".chunk.js";
};